"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.typeRoles = void 0;
exports.typeRoles = {
    tourtip: "region",
    tooltip: "tooltip",
    infotip: "tooltip",
};
